import type {Relation} from "typeorm";
import {Column, Entity, ManyToOne, OneToOne, RelationId} from "typeorm";
import {Min} from "class-validator";
import {BaseEntity} from "@/modules/base/entity";
import {Player, Team} from "@/modules/team/entity";
import {TransferListing} from "@/modules/transfer-market/entity/TransferListing";
import {TransferTeamNegotiation} from "@/modules/transfer-market/entity/TransferTeamNegotiation";
import {TransferPlayerNegotiation} from "@/modules/transfer-market/entity/TransferPlayerNegotiation";
import {TransferOfferStatusEnum} from "@/modules/transfer-market/enums";
import {NegotiationStatusEnum} from "@/modules/diplomacy/enums";
import {CurrencyMetaType} from "@/modules/action-points/interfaces";
import {BankCategory} from "@/modules/finances/enums";

@Entity()
export class TransferOffer extends BaseEntity {
  @ManyToOne(() => TransferListing)
  listing?: Relation<TransferListing>;

  @ManyToOne(() => Team)
  team: Relation<Team>;

  @RelationId((e: TransferOffer) => e.team)
  teamId: number;

  @ManyToOne(() => Player)
  player: Relation<Player>;

  @ManyToOne(() => Team)
  playersTeam?: Relation<Team> | null;

  @OneToOne(() => TransferTeamNegotiation, r => r.offer)
  teamNegotiation?: Relation<TransferTeamNegotiation>;

  @OneToOne(() => TransferPlayerNegotiation, r => r.offer)
  playerNegotiation: Relation<TransferPlayerNegotiation>;

  @Column({type: 'integer', unsigned: true})
  @Min(0)
  price: number;

  @Column({type: 'varchar', enum: TransferOfferStatusEnum})
  status: TransferOfferStatusEnum = TransferOfferStatusEnum.OPENED;

  get canBeClosed() {
    return this.status === TransferOfferStatusEnum.OPENED
      && (this.teamNegotiation && (this.teamNegotiation.canBeClosed || this.teamNegotiation.status === NegotiationStatusEnum.CLOSED))
      && (this.playerNegotiation.canBeClosed || this.playerNegotiation.status === NegotiationStatusEnum.CLOSED);
  }

  get once() {
    return (this.teamNegotiation ? this.teamNegotiation.once : 0)
      + this.playerNegotiation.once;
  }

  get gateMeta(): CurrencyMetaType {
    return {
      category: BankCategory.TRANSFERS,
      label: translator.t('close_negotiation'),
    };
  }
}
